import { create } from "zustand";
import { AuthStatus } from "../enums";

interface UseAuthStatusStore {
    authStatus: AuthStatus;
    userName: string | undefined | null;
    userId: string | undefined | null;
    onSignIn: (userName: string, userId: string) => void;
    onUnauthenticated: () => void;
    onSignOut: () => void;
}

export const useAuthStatusStore = create<UseAuthStatusStore>((store) => ({
    authStatus: AuthStatus.LOADING,
    userName: undefined,
    userId: undefined,
    onSignIn: (userName, userId) =>
        store({
            authStatus: AuthStatus.SIGNED_IN,
            userName,
            userId,
        }),
    onUnauthenticated: () => {
        store({
            authStatus: AuthStatus.UNAUTHENTICATED,
            userName: null,
            userId: null,
        });
    },
    onSignOut: () =>
        store({
            authStatus: AuthStatus.SIGNED_OUT,
            userName: null,
            userId: null,
        }),
}));
